import { type AnyAction, combineReducers } from 'redux';
import Immutable from 'immutable';

import {
    setColorShuffleDataForSlide,
    setColorShuffleIndexForSlide,
    setTemplateColorShuffleIndex,
    setTemplateColorShufflePalettes,
} from 'js/src/data/color-shuffle/color-shuffle-actions';
import type { ColorShuffleInfo } from 'js/src/data/color-shuffle/color-shuffle-types';

export function color_shuffle_index(state = Immutable.Map<string, number>(), action: AnyAction) {
    if (setColorShuffleIndexForSlide.match(action)) {
        return state.set(action.payload.sceneId, action.payload.colorShuffleIndex);
    }
    return state;
}

export function color_shuffle_data(
    state = Immutable.Map<string, ColorShuffleInfo>(),
    action: AnyAction,
) {
    if (setColorShuffleDataForSlide.match(action)) {
        return state.set(action.payload.sceneId, action.payload.colorShuffleInfo);
    }
    return state;
}

export function template_color_shuffle_palettes(state: number[][] = [], action: AnyAction) {
    if (setTemplateColorShufflePalettes.match(action)) {
        return action.payload.palettes;
    }
    return state;
}

export function template_color_shuffle_index(state = 0, action: AnyAction) {
    if (setTemplateColorShuffleIndex.match(action)) {
        return action.payload.colorShuffleIndex;
    }
    return state;
}

export const color_shuffle = combineReducers({
    color_shuffle_data,
    color_shuffle_index,
    template_color_shuffle_palettes,
    template_color_shuffle_index,
});
